import { styled } from "styled-components";

export const QuestionStyled = styled.div`
  font-size: 24px;
`;
